export class SubCategory {

	public _id: string
	public subCategory_id: string
	public name: string
}
